// ----------------------------------------------------------------------------
// Snippet: Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_country-switcher.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var COUNTRY_SWITCHER = '.country-switcher';
var LANG_SWITCHER = '.language-switcher';
var COUNTRY_SWITCHER_TOGGLE = '.country-switcher__toggle';
var LANG_SWITCHER_TOGGLE = '.language-switcher__toggle';
var LANG_SWITCHER_LIST = '.language-switcher__list';
var COUNTRY_SWITCHER_LIST = '.country-switcher__list';
var OPEN_CLASS = 'is-open';
var body = document.querySelector('body');
var countrySwitcher = document.querySelector(COUNTRY_SWITCHER);
var countrySwitcherToggle = document.querySelector(COUNTRY_SWITCHER_TOGGLE);
var languageSwitcherToggle = document.querySelector(LANG_SWITCHER_TOGGLE);
var languageSwitcher = document.querySelector(LANG_SWITCHER);
var languageSwitcherList = document.querySelector(LANG_SWITCHER_LIST);
var countrySwitcherList = document.querySelector(COUNTRY_SWITCHER_LIST);
function closeCountryLangDropdown(toggle, list, switcher) {
  toggle.classList.remove(OPEN_CLASS);
  list.classList.remove(OPEN_CLASS);
  switcher.classList.remove(OPEN_CLASS);
  toggle.setAttribute('aria-expanded', 'false');
}

// Close the switcher if clicking outside
body.addEventListener('click', function (event) {
  if (event.target.closest(COUNTRY_SWITCHER_TOGGLE) === null && document.querySelector(COUNTRY_SWITCHER_TOGGLE) != null) {
    closeCountryLangDropdown(countrySwitcherToggle, countrySwitcherList, countrySwitcher);
  }
  if (languageSwitcherToggle != null) {
    if (event.target.closest(LANG_SWITCHER_TOGGLE) === null) {
      closeCountryLangDropdown(languageSwitcherToggle, languageSwitcherList, languageSwitcher);
    }
  }
});
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul')
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.elements.panel.lastElementChild.addEventListener('keydown', function (event) {
      if (event.keyCode == 9) {
        this.parentNode.toggleAttribute('hidden');
      }
    });
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    var form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  closeSelector(event) {
    var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);